import React from 'react';
// import EnquiryForm from './EnquiryForm';

export default function Home() {
  return (
    <main>
      <section className="relative overflow-hidden bg-gradient-to-br from-brand via-brand/80 to-brand/50 text-white">
        <div className="section-container grid gap-10 py-12 lg:grid-cols-2 lg:items-center">
          <div className="space-y-6">
            <h1 className="text-3xl font-bold leading-tight sm:text-3xl">
              Leading Gynecologist in Bhopal:
              <span className="block">Dr. Priya Bhave Chittawar</span>
            </h1>

            <div className="flex justify-center lg:hidden">
              <img
                className="w-full max-w-md rounded-none border border-white/10 object-cover shadow-soft"
                src={`${process.env.PUBLIC_URL}/images/dr_priya.jpg`}
                alt="Dr. Priya Bhave Chittawar"
                fetchPriority="high"
              />
            </div>
            
            <p className="max-w-xl text-white/85">
              Dr. Priya Bhave Chittawar is a Reproductive Medicine specialist and the best Gynecologist in Bhopal, trained in Christian Medical College, Vellore, one of the best institutions of India. She has expertise in Reproductive Medicine and minimally invasive reproductive surgery. Reproductive Medicine deals with hormonal disorders of males and females including subfertility and includes assisted reproductive technologies like IVF, ICSI, egg donation and gamut of reproductive tract surgeries like laparoscopy and hysteroscopy. Gynecologist deals with the health of the female reproductive system.
            </p>
            <a href="/about" className="btn-primary inline-flex w-max">
              Read more
            </a>
          </div>

          <div className="hidden justify-center lg:flex lg:justify-end">
            <img
              className="h-100 w-full max-w-md rounded-none object-cover shadow-soft"
              src={`${process.env.PUBLIC_URL}/images/dr_priya.jpg`}
              alt="Dr. Priya Bhave Chittawar"
            />
          </div>
        </div>
      </section>

      <section className="section-container py-12">
        <h2 className="text-center text-3xl font-semibold text-brand">Treatments</h2>
        <div className="mt-12 grid gap-8 md:grid-cols-2">
          <article className="card">
            <h3 className="text-xl font-semibold text-brand">Infertility</h3>
            <p className="mt-3 text-neutral/70">
              Infertility is stressful condition. While it is not considered a disease, it causes lot of mental and psychological upheavals. It also leads to social isolation and withdrawal especially in traditional societies.
            </p>
            <img
              className="mt-6 h-40 w-full object-contain"
              src={`${process.env.PUBLIC_URL}/images/infertility.png`}
              alt="Infertility"
            />
          </article>

          <article className="card">
            <h3 className="text-xl font-semibold text-brand">Laparoscopic Myomectomy</h3>
            <p className="mt-3 text-neutral/70">
              Fibroids or myomas are common benign tumors in women. Almost 20% of women with infertility have fibroids. If the fibroid is more than 4 cm or is inside the lining of uterus (submucous) it can affect fertility and needs to be removed.
            </p>
            <img
              className="mt-6 h-40 w-full object-contain"
              src={`${process.env.PUBLIC_URL}/images/LaparoscopicMyomectomy.png`}
              alt="Laparoscopic Myomectomy"
            />
          </article>
        </div>
      </section>

      {/* <section className="bg-accent text-white">
        <div className="section-container grid py-12 lg:grid-cols-2 lg:items-start">
          // <EnquiryForm
          //   theme="dark"
          //   title="Enquiry Form"
          //   description="Fill out some info and we will be in touch shortly."
          //   onSubmit={(formData) => console.log('Form submitted:', formData)}
          // />
        </div>
      </section> */}
    </main>
  );
}
